module.exports = __webpack_public_path__ + "static/media/attack.8a87867c.png";